export default __webpack_public_path__ + "static/user1-2319d76a51ef658d980b453037152e94.jpg";